export class SqlIdeUrlHolder {
    public static sqlIdeURL: string = "";
}